import { computed } from 'vue'
import { sessionStore } from '@/stores/session'
import { usersStore } from '@/stores/users'

export function useCurrentUser() {
  const session = sessionStore()
  const users = usersStore()

  const profile = computed(() => users.getUser(session.user))
  const name = computed(() => profile.value?.full_name || profile.value?.name || '')
  const initials = computed(() => {
    const parts = name.value.trim().split(/\s+/).filter(Boolean)
    return parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase() || '?'
  })

  return {
    profile,
    name,
    initials,
  }
}
